// 進行異步執行
import { apiRestrictedDeposit, apiGetPCSI18nJSON, apiGetResponseServerData } from '@/resource'
import { apiPCSEnabled } from '@/resource/pcs'
import { I18N_PAYMENT_CENTER_MAP } from '@/constants/language'
import i18n from '@/lang'

export default {
  async actionRestrictDeposit({ commit, state }) {
    if (state.restrictedDeposit.length > 0) return state.restrictedDeposit
    return new Promise((resolve, reject) => {
      apiRestrictedDeposit().then(result => {
        let data = result.data.length <= 0 ? 0 : result.data
        commit('setRestrictedDeposit', data)
        resolve(data)
      })
    })
  },
  actionSetCcValidateDialogVisible({ commit }, payload) {
    commit('SET_CCVALIDATEDIALOGVISIBLE', payload)
  },
  actionSetThirdPartyDepositData({ commit }, data) {
    commit('setThirdPartyDepositData', data)
  },
  actionSetDisableOtherMethod({ commit }, data) {
    commit('setDisableOtherMethod', data)
  },
  actionSetHasAvailableCard({ commit }, data) {
    commit('setHasAvailableCard', data)
  },
  actionSetWithdrawSortInfo({ commit }, data) {
    commit('setWithdrawSortInfo', data)
  },
  actionSetBridgePayData({ commit }, data) {
    commit('setBridgePayData', data)
  },
  actionSetCheckoutCCData({ commit }, data) {
    commit('setCheckoutCCData', data)
  },
  actionSetIsUsePcs({ commit }, data) {
    return new Promise((resolve, reject) => {
      apiPCSEnabled().then(result => {
        let data = result.data
        commit('setIsUsePcs', data.data)
        resolve(data)
      })
    })
  },
  async actionSetPCSI18n({ commit, rootState }, data) {
    const lang = I18N_PAYMENT_CENTER_MAP[rootState.common.lang] || 'en_US'
    const localCache = window.__locale_pcs_code ? window.__locale_pcs_code : (window.__locale_pcs_code = {})
    if (!localCache[lang]) {
      localCache[lang] = true
      try {
        const resUrl = await apiGetPCSI18nJSON(lang)
        if (resUrl.data.code === 0 && resUrl.data.data) {
          const res = await apiGetResponseServerData(resUrl.data.data)
          commit('setPCSI18n', res.data)
          i18n.mergeLocaleMessage(rootState.common.lang, res.data)
        } else {
          console.log('Invalid response from apiGetPCSI18nJSON')
        }
      } catch (error) {
        console.error('Error in actionSetPCSI18n:', error)
      }
    }
  },
  actionSetDefaultDepositAccountNum({ commit }, data) {
    commit('setDefaultDepositAccountNum', data)
  },
}
